import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Msisdn } from '../shared/msisdn/msisdns';

@Injectable()
export class PhoneNumbersService {
  constructor(private http: HttpClient) {}

  getPhoneNumbers(): Observable<Msisdn[]> {
    return this.http.get<Msisdn[]>('/inbound/configuration/numbers/');
  }

  getNumberSettings(numberId) {
    return this.http.get(`/inbound/configuration/numbers/${numberId}`);
  }
}
